(function(){
  if (window.TeMag && window.TeMag.init) { window.TeMag.init(); return; }

var TeMag = (function(){
  function r(n){ return Math.round(n*100)/100; }
  function trimNum(n,d){ return String(+(+n).toFixed(d)); }
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function parseNum(s){
    var m; s = String(s).trim();
    if ((m = s.match(/^(\d+)[\s-]+(\d+)\s*\/\s*(\d+)$/))) return +m[1] + m[2]/m[3];
    if ((m = s.match(/^(\d+)\s*\/\s*(\d+)$/))) return m[1]/m[2];
    if (/^\d*\.?\d+$/.test(s)) return parseFloat(s);
    return NaN;
  }
  function normRaw(s){ return String(s).trim().replace(/\s*\/\s*/g,'/').replace(/[\s-]+(?=\d+\/)/,' '); }

  var DEFAULT_ROLES = { sphere:['d'], disc:['d','t'], ring:['d','id','t'], block:['w','l','t'] };

  function roleOf(word){
    word = word.toLowerCase();
    if (/inner|\bi\.?d\b/.test(word)) return 'id';
    if (/width/.test(word)) return 'w';
    if (/length/.test(word)) return 'l';
    if (/thick|height/.test(word)) return 't';
    if (/outer|\bo\.?d\b|diam/.test(word)) return 'd';
    return null;
  }

  function parseDir(raw){
    var s = String(raw || '').toLowerCase();
    if (/diamet/.test(s)) return 'diametric';
    if (/axial|thick|through/.test(s)) return 'axial';
    return null;
  }

  function parseSize(raw, dirRaw, defUnit){
    var low = String(raw || '').toLowerCase().replace(/[\u201d\u2033]/g,'"');
    var pm = low.match(/\(([^)]*)\)/), paren = pm ? pm[1] : '';
    var body = low.replace(/\([^)]*\)/g,' ');
    var unit = /mm|millimet/.test(body) ? 'mm' : (/inch|\bin\b|"/.test(body) ? 'in' : (defUnit === 'mm' ? 'mm' : 'in'));
    body = body.replace(/millimeters?|millimetres?|mm|inches|inch|\bin\b\.?|"|diameter|\bdia\b\.?|thickness|thick|\u00f8|\u2300/g, ' ');
    var parts = body.split(/\s*(?:\u00d7|\*|\bby\b|x)\s*/).map(function(p){ return p.trim(); }).filter(Boolean);
    if (parts.length < 1 || parts.length > 3) return { error:'Size needs 1 to 3 numbers.' };
    var vals = parts.map(parseNum);
    for (var i = 0; i < vals.length; i++) if (!(vals[i] > 0)) return { error:'"' + parts[i] + '" is not a size above zero.' };

    var roles = paren ? paren.split(/\s+(?:x|\u00d7|by)\s+|\s*[\u00d7*]\s*/).map(roleOf) : [];
    var shape;
    if (vals.length === 1) shape = 'sphere';
    else if (vals.length === 2) shape = 'disc';
    else if (roles.indexOf('id') > -1) shape = 'ring';
    else if (roles.indexOf('w') > -1 || roles.indexOf('l') > -1) shape = 'block';
    else shape = /thick/.test(String(dirRaw || '').toLowerCase()) ? 'block' : 'ring';

    var def = DEFAULT_ROLES[shape];
    var ok = roles.length === vals.length && roles.every(function(x){ return x && def.indexOf(x) > -1; }) &&
             def.every(function(x){ return roles.indexOf(x) > -1; });
    if (!ok) roles = def;

    var spec = { shape:shape, unit:unit, v:{}, raw:{} };
    roles.forEach(function(role, i){ spec.v[role] = vals[i]; spec.raw[role] = normRaw(parts[i]); });
    if (shape === 'ring' && !(spec.v.id < spec.v.d)) return { error:'Inner diameter must be smaller than the outer diameter.' };

    var d = String(dirRaw || '').toLowerCase();
    if (shape === 'block') spec.mag = (!d || /thick|axial|through/.test(d)) ? 'axial' : null;
    else spec.mag = d ? parseDir(d) : 'axial';
    if (!spec.mag) return { error:'Magnetization direction "' + dirRaw + '" is not supported for this shape.' };
    return spec;
  }

  function parseCs(raw, defUnit){
    if (raw == null || !String(raw).trim()) return null;
    var low = String(raw).toLowerCase().replace(/[\u201d\u2033]/g,'"').replace(/\([^)]*\)/g,' ');
    var spacing = null;
    var sm = low.match(/(\d+(?:\.\d+)?(?:[\s-]+\d+\/\d+|\/\d+)?)\s*(millimeters?|millimetres?|mm|inches|inch|in\b\.?|")?\s*(?:apart|c-c|c\/c|center[\s-]+to[\s-]+center|on[\s-]+center)/);
    if (sm){
      spacing = { v:parseNum(sm[1].trim()), raw:normRaw(sm[1]), unit:sm[2] ? (/^m/.test(sm[2]) ? 'mm' : 'in') : null };
      low = low.replace(sm[0], ' ');
      if (!(spacing.v > 0)) spacing = null;
    }
    var am = low.match(/(?:\bat\b|@)\s*(\d+(?:\.\d+)?)/) || low.match(/(\d+(?:\.\d+)?)\s*(?:\u00b0|\u00ba|deg)/);
    var angle = am ? +am[1] : 82;
    var body = low.replace(/(?:\bat\b|@)\s*\d+(?:\.\d+)?\s*(?:\u00b0|\u00ba|degrees?|deg)?/g,' ')
                  .replace(/\d+(?:\.\d+)?\s*(?:\u00b0|\u00ba|degrees?|deg)/g,' ');
    var unit = /mm|millimet/.test(body) ? 'mm' : (/inch|\bin\b|"/.test(body) ? 'in' : (defUnit === 'mm' ? 'mm' : 'in'));
    body = body.replace(/millimeters?|millimetres?|mm|inches|inch|\bin\b\.?|"|diameter|\bdia\b\.?|countersunk|countersink|\bcs\b|\bhole\b/g,' ');
    var parts = body.split(/\s*(?:\u00d7|\*|\bby\b|x)\s*/).map(function(p){ return p.replace(/^[\s\-\u2013\u2014,;:]+|[\s\-\u2013\u2014,;:]+$/g, ''); }).filter(Boolean);
    if (parts.length !== 2) return { error:'Countersink needs "countersink diameter x hole diameter".' };
    var D = parseNum(parts[0]), H = parseNum(parts[1]);
    if (!(D > 0) || !(H > 0)) return { error:'Countersink sizes must be above zero.' };
    if (H > D){ var t = D; D = H; H = t; t = parts[0]; parts[0] = parts[1]; parts[1] = t; }
    if (!(angle > 0 && angle < 180)) angle = 82;
    if (spacing && !spacing.unit) spacing.unit = unit;
    return { D:D, H:H, angle:angle, rawD:normRaw(parts[0]), rawH:normRaw(parts[1]), unit:unit, spacing:spacing };
  }

  function csVariants(spec, dirRaw){
    if (!spec.cs || spec.mag !== 'axial') return [{}];
    var d = String(dirRaw || '').toLowerCase();
    var pair = /\bpairs?\b/.test(d), n = /\bnorth\b/.test(d), s = /\bsouth\b/.test(d);
    var NV = { axialNorth:'top', caption:'Countersunk on North side' };
    var SV = { axialNorth:'bottom', caption:'Countersunk on South side' };
    if (pair || (n && s) || (!n && !s)) return [NV, SV];
    return n ? [NV] : [SV];
  }

  function addCs(spec, csRaw){
    if (!spec || spec.error || (spec.shape !== 'disc' && spec.shape !== 'block')) return spec;
    var cs = parseCs(csRaw, spec.unit);
    if (!cs) return spec;
    if (cs.error){ spec.csError = cs.error; return spec; }
    var f = cs.unit === spec.unit ? 1 : (cs.unit === 'mm' ? 1/25.4 : 25.4);
    cs.Dm = cs.D * f; cs.Hm = cs.H * f;
    cs.depth = (cs.Dm - cs.Hm) / 2 / Math.tan(cs.angle * Math.PI / 360);
    if (cs.spacing && spec.shape === 'block'){
      var fs2 = cs.spacing.unit === spec.unit ? 1 : (cs.spacing.unit === 'mm' ? 1/25.4 : 25.4);
      cs.Sm = cs.spacing.v * fs2;
    }
    spec.cs = cs;
    return spec;
  }

  function parseLen(raw, unit){
    if (raw == null) return 0;
    var s = String(raw).toLowerCase().replace(/[\u201d\u2033]/g,'"').trim();
    if (!s) return 0;
    var u = /mm|millimet/.test(s) ? 'mm' : (/inch|\bin\b|"/.test(s) ? 'in' : unit);
    var n = parseNum(s.replace(/^r\s*/, '').replace(/millimeters?|millimetres?|mm|inches|inch|\bin\b\.?|"/g, '').trim());
    if (!(n > 0)) return 0;
    return u === unit ? n : (u === 'mm' ? n/25.4 : n*25.4);
  }

  function hexRgb(c){
    var s = String(c || '').trim().toLowerCase(), m;
    if (s === 'white') return [255, 255, 255];
    if ((m = s.match(/^#?([0-9a-f]{3})$/))) return m[1].split('').map(function(x){ return parseInt(x + x, 16); });
    if ((m = s.match(/^#?([0-9a-f]{6})$/))) return [0, 2, 4].map(function(i){ return parseInt(m[1].substr(i, 2), 16); });
    if ((m = s.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/))) return [+m[1], +m[2], +m[3]];
    return null;
  }

  function label(raw, v, unit, conv, inch){
    var t;
    if (unit === 'in'){
      t = (String(raw).indexOf('/') > -1 || /^\d*\.?\d+$/.test(String(raw)) ? raw : trimNum(v,4)) + inch;
      if (conv) t += ' (' + trimNum(v*25.4,2) + ' mm)';
    } else {
      t = (/^\d*\.?\d+$/.test(String(raw)) ? raw : trimNum(v,3)) + ' mm';
      if (conv) t += ' (' + trimNum(v/25.4,3) + inch + ')';
    }
    return t;
  }

  var DEFAULTS = { north:'#e0212c', south:'#80848b', axialNorth:'top', diametricNorth:'left', max:200, tilt:0.32,
                   dims:true, letters:true, phi:true, conv:false, dimColor:'#3a3f47', fs:14, inch:'"', bg:'#ffffff', finish:'glossy', caption:'', csTilt:0.5, csBlockTurn:24, edgeRadius:'', glossIntensity:1, glossColor:'#ffffff' };

  function build(spec, opts){
    var cfg = {}, k;
    for (k in DEFAULTS) cfg[k] = DEFAULTS[k];
    for (k in opts || {}) if (opts[k] !== undefined && opts[k] !== null && opts[k] !== '') cfg[k] = opts[k];
    var N = cfg.north, S = cfg.south, c = cfg.dimColor, fs = +cfg.fs, tilt = +cfg.tilt, maxPx = +cfg.max;
    if (spec.cs && +cfg.csTilt > tilt) tilt = +cfg.csTilt;
    var v = spec.v, unit = spec.unit;
    var phi = cfg.phi ? '\u00d8 ' : '';
    var L = function(key){ return label(spec.raw[key], v[key], unit, cfg.conv, cfg.inch); };

    var out = [], bx = { x1:0, y1:0, x2:0, y2:0 };
    function ext(x1,y1,x2,y2){ bx.x1 = Math.min(bx.x1,x1,x2); bx.y1 = Math.min(bx.y1,y1,y2); bx.x2 = Math.max(bx.x2,x1,x2); bx.y2 = Math.max(bx.y2,y1,y2); }
    function css(o){ var a = []; for (var p in o) a.push(p + ':' + o[p]); return a.join(';'); }
    function node(o, text, inner){
      var tag = text != null ? 'span' : 'div';
      return '<' + tag + ' style="' + esc('position:absolute;' + css(o)) + '">' + (text != null ? esc(text) : (inner || '')) + '</' + tag + '>';
    }
    function add(o, text){ out.push(node(o, text)); }
    function px(n){ return r(n) + 'px'; }
    function textW(t){ return t.length * fs * 0.58; }
    var TH = fs * 1.25;

    var GLOSS = cfg.finish !== 'satin';
    var SH = GLOSS
      ? 'linear-gradient(90deg,rgba(0,0,0,.48) 0%,rgba(0,0,0,.18) 7%,rgba(255,255,255,.10) 14%,rgba(255,255,255,.78) 21%,rgba(255,255,255,.22) 26%,rgba(255,255,255,0) 36%,rgba(0,0,0,.06) 55%,rgba(255,255,255,.26) 71%,rgba(255,255,255,.04) 78%,rgba(0,0,0,.22) 90%,rgba(0,0,0,.52) 100%)'
      : 'linear-gradient(90deg,rgba(0,0,0,.30) 0%,rgba(255,255,255,.20) 22%,rgba(255,255,255,.06) 45%,rgba(0,0,0,.10) 72%,rgba(0,0,0,.34) 100%)';
    var HL = GLOSS
      ? 'radial-gradient(ellipse 30% 45% at 30% 38%,rgba(255,255,255,.70),rgba(255,255,255,0) 100%),linear-gradient(165deg,rgba(255,255,255,.42) 0%,rgba(255,255,255,.10) 38%,rgba(255,255,255,0) 52%,rgba(0,0,0,.14) 100%)'
      : 'radial-gradient(ellipse at 38% 40%,rgba(255,255,255,.28),rgba(255,255,255,0) 62%)';
    var RIM = GLOSS ? 'inset 0 1px 1px rgba(255,255,255,.65),inset 0 0 0 1px rgba(0,0,0,.12)' : 'inset 0 0 0 1px rgba(0,0,0,.08)';

    var axial = spec.mag === 'axial';
    var nFirst = axial ? cfg.axialNorth !== 'bottom' : cfg.diametricNorth !== 'right';
    var A = nFirst ? N : S, B = nFirst ? S : N;
    var aL = nFirst ? 'N' : 'S', bL = nFirst ? 'S' : 'N';
    var split = 'linear-gradient(90deg,' + A + ' 50%,' + B + ' 50%)';
    var where = axial ? (spec.shape === 'block' ? 'magnetized through thickness, ' : 'axially magnetized, ') + (nFirst ? 'north pole on top' : 'north pole on bottom')
                      : 'diametrically magnetized, ' + (nFirst ? 'north pole on left half' : 'north pole on right half');

    function arrow(dir, x, y){
      var a = 8, b = 3.5, tb = b + 'px solid transparent', s = { width:'0', height:'0' };
      if (dir === 'left')  { s.left = px(x);   s.top = px(y-b); s['border-top'] = tb; s['border-bottom'] = tb; s['border-right'] = a + 'px solid ' + c; }
      if (dir === 'right') { s.left = px(x-a); s.top = px(y-b); s['border-top'] = tb; s['border-bottom'] = tb; s['border-left'] = a + 'px solid ' + c; }
      if (dir === 'up')    { s.left = px(x-b); s.top = px(y);   s['border-left'] = tb; s['border-right'] = tb; s['border-bottom'] = a + 'px solid ' + c; }
      if (dir === 'down')  { s.left = px(x-b); s.top = px(y-a); s['border-left'] = tb; s['border-right'] = tb; s['border-top'] = a + 'px solid ' + c; }
      return node(s);
    }
    function textNode(x, y, t, tf){ return node({ left:px(x), top:px(y), transform:tf, 'white-space':'nowrap', 'line-height':'1.2' }, t); }

    function hDim(x1, x2, y, fromY, t, above){
      var len = x2 - x1;
      var top = above ? y - 5 : fromY, hgt = above ? fromY - (y - 5) : y + 5 - fromY;
      out.push(node({ left:px(x1), top:px(top), width:px(len), height:px(hgt), 'border-left':'1px solid ' + c, 'border-right':'1px solid ' + c, opacity:'.6' }));
      out.push(node({ left:px(x1), top:px(y), width:px(len), height:'1px', background:c }));
      if (len >= 26){ out.push(arrow('left', x1, y+0.5)); out.push(arrow('right', x2, y+0.5)); }
      else { out.push(arrow('right', x1, y+0.5)); out.push(arrow('left', x2, y+0.5)); }
      var ly = above ? y - 6 - TH : y + 6, w = textW(t);
      out.push(textNode((x1+x2)/2, ly, t, 'translateX(-50%)'));
      ext((x1+x2)/2 - w/2, ly, (x1+x2)/2 + w/2, ly + TH);
      ext(x1 - (len < 26 ? 9 : 0), top, x2 + (len < 26 ? 9 : 0), top + hgt);
    }
    function vDim(x, y1, y2, fromX, t){
      var len = y2 - y1;
      out.push(node({ left:px(fromX+3), top:px(y1), width:px(x - fromX - 1), height:px(len), 'border-top':'1px solid ' + c, 'border-bottom':'1px solid ' + c, opacity:'.6' }));
      out.push(node({ left:px(x), top:px(y1), width:'1px', height:px(len), background:c }));
      if (len >= 26){ out.push(arrow('up', x+0.5, y1)); out.push(arrow('down', x+0.5, y2)); }
      else { out.push(arrow('down', x+0.5, y1)); out.push(arrow('up', x+0.5, y2)); }
      out.push(textNode(x + 9, (y1+y2)/2, t, 'translateY(-50%)'));
      ext(fromX, y1 - (len < 26 ? 9 : 0), x + 9 + textW(t), y2 + (len < 26 ? 9 : 0));
      ext(x, (y1+y2)/2 - TH/2, x, (y1+y2)/2 + TH/2);
    }
    function sDim(x1, y1, x2, y2, t, off){
      var dx = x2 - x1, dy = y2 - y1, len = Math.sqrt(dx*dx + dy*dy), ang = Math.atan2(dy, dx);
      var inner = [], neg = off < 0;
      var eTop = neg ? off - 2 : 3, eH = neg ? -off - 1 : off + 2;
      inner.push(node({ left:'0', top:px(eTop), width:px(len), height:px(eH), 'border-left':'1px solid ' + c, 'border-right':'1px solid ' + c, opacity:'.6' }));
      inner.push(node({ left:'0', top:px(off), width:px(len), height:'1px', background:c }));
      if (len >= 26){ inner.push(arrow('left', 0, off+0.5)); inner.push(arrow('right', len, off+0.5)); }
      else { inner.push(arrow('right', 0, off+0.5)); inner.push(arrow('left', len, off+0.5)); }
      var ty = neg ? off + 5 : off + 5;
      inner.push(textNode(len/2, ty, t, 'translateX(-50%)'));
      out.push(node({ left:px(x1), top:px(y1), width:'0', height:'0', transform:'rotate(' + r(ang*180/Math.PI) + 'deg)', 'transform-origin':'0 0' }, null, inner.join('')));
      var ca = Math.cos(ang), sa = Math.sin(ang), tw = textW(t);
      [[0,0],[len,0],[len/2 - tw/2, ty],[len/2 + tw/2, ty + TH],[-9,off],[len+9,off],[0,eTop],[len,eTop]].forEach(function(p){
        var gx = x1 + p[0]*ca - p[1]*sa, gy = y1 + p[0]*sa + p[1]*ca; ext(gx, gy, gx, gy);
      });
    }

    var pf;
    function pole(x, y, t, size){ out.push(node({ left:px(x), top:px(y), transform:'translate(-50%,-50%)', 'font-size':px(size || pf), 'font-weight':'700', 'line-height':'1', color:'#fff', 'text-shadow':'0 1px 2px rgba(0,0,0,.4)' }, t)); }
    var erUnits = 0, sc, erRaw = String(cfg.edgeRadius == null ? '' : cfg.edgeRadius).trim();
    if (/%\s*$/.test(erRaw)){
      var pct = parseFloat(erRaw), vv = spec.v;
      var smallest = spec.shape === 'block' ? Math.min(vv.w, vv.l, vv.t)
                   : spec.shape === 'ring' ? Math.min(vv.t, (vv.d - vv.id)/2)
                   : Math.min(vv.d || Infinity, vv.t || Infinity);
      if (pct > 0 && isFinite(smallest)) erUnits = smallest * Math.min(pct, 50) / 100;
    } else erUnits = parseLen(erRaw, spec.unit);
    function edgePx(){ return erUnits > 0 && sc ? erUnits * sc : 0; }

    function roundPoly(pts, rr){
      var outP = [], n = pts.length;
      for (var i = 0; i < n; i++){
        var P = pts[i], Q = pts[(i - 1 + n) % n], S2 = pts[(i + 1) % n];
        var ax = Q[0]-P[0], ay = Q[1]-P[1], bx = S2[0]-P[0], by = S2[1]-P[1];
        var la = Math.sqrt(ax*ax + ay*ay), lb = Math.sqrt(bx*bx + by*by);
        if (la < 0.01 || lb < 0.01){ outP.push(P); continue; }
        ax /= la; ay /= la; bx /= lb; by /= lb;
        var ang = Math.acos(Math.max(-1, Math.min(1, ax*bx + ay*by)));
        var d = Math.min(rr / Math.tan(ang/2), la/2, lb/2);
        var p0 = [P[0] + ax*d, P[1] + ay*d], p2 = [P[0] + bx*d, P[1] + by*d];
        for (var k = 0; k <= 6; k++){
          var u = k/6, m = 1 - u;
          outP.push([m*m*p0[0] + 2*m*u*P[0] + u*u*p2[0], m*m*p0[1] + 2*m*u*P[1] + u*u*p2[1]]);
        }
      }
      return outP;
    }
    function edgeBand(p1, p2, wid, color, center, cxy){
      var dx = p2[0]-p1[0], dy = p2[1]-p1[1], len = Math.sqrt(dx*dx + dy*dy);
      if (len < 1) return '';
      var ang = Math.atan2(dy, dx), nx = -Math.sin(ang), ny = Math.cos(ang), bg, top;
      if (center){ top = -wid; bg = 'linear-gradient(180deg,rgba(0,0,0,0),' + color + ' 50%,rgba(0,0,0,0))'; wid = wid*2; }
      else if ((cxy[0]-p1[0])*nx + (cxy[1]-p1[1])*ny >= 0){ top = 0; bg = 'linear-gradient(180deg,' + color + ',rgba(0,0,0,0))'; }
      else { top = -wid; bg = 'linear-gradient(0deg,' + color + ',rgba(0,0,0,0))'; }
      return node({ left:px(p1[0]), top:px(p1[1]), width:px(len), height:px(wid), transform:'rotate(' + r(ang*180/Math.PI) + 'deg) translateY(' + r(top) + 'px)', 'transform-origin':'0 0', background:bg });
    }
    function roundBlock(from, BW, BH, sil, inner, rr){
      var rp = roundPoly(sil, rr), cxy = [0, 0];
      sil.forEach(function(p){ cxy[0] += p[0]/sil.length; cxy[1] += p[1]/sil.length; });
      var bands = [], bw = Math.max(1, rr * 0.9);
      inner.forEach(function(ed){ bands.push(edgeBand(ed[0], ed[1], bw*0.8, 'rgba(255,255,255,' + (GLOSS ? '.55' : '.32') + ')', true)); });
      for (var i = 0; i < sil.length; i++){
        var p1 = sil[i], p2 = sil[(i + 1) % sil.length];
        var up = (p1[1] + p2[1])/2 < cxy[1] - 1 && Math.abs(p2[1] - p1[1]) < Math.abs(p2[0] - p1[0]) * 1.5;
        bands.push(edgeBand(p1, p2, bw * 1.2, up ? 'rgba(255,255,255,' + (GLOSS ? '.40' : '.24') + ')' : 'rgba(0,0,0,.30)', false, cxy));
      }
      var clip = 'polygon(' + rp.map(function(p){ return r(p[0]) + 'px ' + r(p[1]) + 'px'; }).join(',') + ')';
      var inside = out.splice(from, out.length - from).join('') + bands.join('');
      out.push(node({ left:'0', top:'0', width:px(BW), height:px(BH), 'clip-path':clip, '-webkit-clip-path':clip }, null, inside));
    }

    function poleStack(x, upperY, lowerY, halfH, width){
      var sz = Math.min(26, width*0.3, halfH/1.1);
      if (sz < 9) return;
      pole(x, upperY, aL, r(sz));
      pole(x, lowerY, bL, r(sz));
    }
    function polePair(options){
      var best = 0, i;
      for (i = 0; i < options.length; i++) best = Math.max(best, options[i].s);
      if (best < 9) return;
      for (i = 0; i < options.length; i++){
        var o = options[i];
        if (o.s >= best * 0.8){ var s = r(o.s); pole(o.a[0], o.a[1], aL, s); pole(o.b[0], o.b[1], bL, s); return; }
      }
    }

    function countersink(cx, cy, c, d, h, sc, withDims){
      var cs = spec.cs, Dc = cs.Dm*sc, Dh = cs.Hm*sc, R = Dc/2, rh = Dh/2;
      var dz = Math.min(h, cs.depth*sc);
      var loc = function(Y){ return [-c*Y/d, Y/d]; };
      var skew = r(Math.atan(-c)*180/Math.PI);
      var hc = loc(dz), inner = [];
      var wallBase = axial ? A : split;
      if (axial && h/2 > dz){
        var sp = loc(h/2 - dz);
        inner.push(node({ left:px(sp[0]), top:px(sp[1]), width:px(Dh), height:px(Dh), 'border-radius':'50%', background:B }));
        inner.push(node({ left:px(sp[0]), top:px(sp[1] + rh), width:px(Dh), height:px(Dh*4 + h/d), background:B,
                          transform:'skewX(' + skew + 'deg)', 'transform-origin':'50% 0' }));
      } else if (axial) wallBase = B;
      inner.push(node({ left:'0', top:'0', width:'100%', height:'100%',
                        background:'linear-gradient(90deg,rgba(0,0,0,.55),rgba(0,0,0,.72) 35%,rgba(0,0,0,.66) 70%,rgba(0,0,0,.50))' }));
      var bo = loc(h - dz);
      inner.push(node({ left:px(bo[0]), top:px(bo[1]), width:px(Dh), height:px(Dh), 'border-radius':'50%', background:cfg.bg }));
      var hole = node({ left:px(R + hc[0] - rh), top:px(R + hc[1] - rh), width:px(Dh), height:px(Dh), 'border-radius':'50%',
                        overflow:'hidden', background:wallBase, 'box-shadow':'inset 0 ' + r(1.1/d) + 'px 0 rgba(255,255,255,' + (GLOSS ? '.55' : '.35') + '),inset 0 0 0 ' + r(0.9/d) + 'px rgba(0,0,0,.55),inset 0 ' + r(3/d) + 'px ' + r(4/d) + 'px rgba(0,0,0,.45)' }, null, inner.join(''));

      var throat = Math.max(5, Math.min(95, (R + (dz - rh*d)/d) / Dc * 100));
      var CONE = (GLOSS ? 'radial-gradient(ellipse 38% 16% at 44% 12%,rgba(255,255,255,.55),rgba(255,255,255,0) 100%),' : '') +
        'linear-gradient(90deg,rgba(0,0,0,.36) 0%,rgba(0,0,0,.08) 26%,rgba(0,0,0,0) 45%,rgba(0,0,0,.06) 65%,rgba(0,0,0,.40) 100%),' +
        'linear-gradient(180deg,rgba(255,255,255,' + (GLOSS ? '.30' : '.16') + ') 0%,rgba(255,255,255,.05) ' + r(throat*0.45) + '%,rgba(0,0,0,.18) ' + r(throat*0.8) + '%,rgba(0,0,0,.42) ' + r(throat) + '%,rgba(0,0,0,.50) 100%)';
      out.push(node({ left:px(cx - R), top:px(cy - R), width:px(Dc), height:px(Dc), 'border-radius':'50%', overflow:'hidden',
                      background:CONE + ',' + (axial ? A : split), transform:'matrix(1,0,' + r(c*1000)/1000 + ',' + r(d*1000)/1000 + ',0,0)',
                      'transform-origin':'50% 50%',
                      'box-shadow':'inset 0 ' + r(1.5/d) + 'px ' + r(2/d) + 'px rgba(0,0,0,.40),inset 0 -' + r(1/d) + 'px ' + r(3/d) + 'px rgba(0,0,0,.16)' }, null, hole));
      if (cfg.dims && withDims !== false){
        var csTxt = phi + label(cs.rawD, cs.D, cs.unit, cfg.conv, cfg.inch) + ' \u00d7 ' + trimNum(cs.angle, 1) + '\u00b0';
        var hTxt = phi + label(cs.rawH, cs.H, cs.unit, cfg.conv, cfg.inch);
        hDim(cx - rh, cx + rh, -14, cy - 2, hTxt, true);
        hDim(cx - R, cx + R, -14 - TH - 18, cy - 2, csTxt, true);
      }
    }

    function cylinderRound(w, h, e, rr){
      var t = e / w, R = w/2;
      rr = Math.min(rr, h/2 * 0.96, R * 0.45);
      var steps = Math.max(3, Math.min(32, Math.ceil(rr / 1.1)));
      var top = axial ? A : split, bot = axial ? B : split;
      var ring = function(rho, D, bg){
        add({ left:px(R - rho), top:px(e/2 + D - rho*t), width:px(2*rho), height:px(2*rho*t), 'border-radius':'50%', background:bg });
      };
      var i, a, rho;
      for (i = 0; i <= steps; i++){
        a = -Math.PI/2 + (Math.PI/2) * i/steps;
        rho = R - rr + rr*Math.cos(a);
        ring(rho, h - rr - rr*Math.sin(a), SH + ',linear-gradient(rgba(0,0,0,' + r(0.30*(-Math.sin(a))) + '),rgba(0,0,0,' + r(0.30*(-Math.sin(a))) + ')),' + bot);
      }
      if (axial){
        add({ left:'0', top:px(e/2 + h/2), width:px(w), height:px(Math.max(0, h/2 - rr) + 0.5), background:SH + ',' + B });
        add({ left:'0', top:px(h/2), width:px(w), height:px(e), 'border-radius':'50%', background:SH + ',' + A });
        add({ left:'0', top:px(e/2 + rr), width:px(w), height:px(Math.max(0, h/2 - rr) + 0.5), background:SH + ',' + A });
      } else {
        add({ left:'0', top:px(e/2 + rr), width:px(w), height:px(Math.max(0, h - 2*rr) + 0.5), background:SH + ',' + split });
      }
      for (i = 0; i <= steps; i++){
        a = (Math.PI/2) * i/steps;
        rho = R - rr + rr*Math.cos(a);
        var side = 1 - Math.sin(a), hi = Math.sin(2*a) * (GLOSS ? 0.42 : 0.24) * Math.max(0.55, 1 - rr/h);
        ring(rho, rr - rr*Math.sin(a),
             'linear-gradient(rgba(255,255,255,' + r(hi) + '),rgba(255,255,255,' + r(hi) + ')),' +
             'linear-gradient(90deg,rgba(0,0,0,' + r(0.30*side) + ') 0%,rgba(255,255,255,' + r(0.2*side) + ') 22%,rgba(0,0,0,0) 50%,rgba(0,0,0,' + r(0.34*side) + ') 100%),' + top);
      }
      var fr = R - rr;
      add({ left:px(rr), top:px(e/2 - fr*t), width:px(2*fr), height:px(2*fr*t), 'border-radius':'50%', background:HL + ',' + top });
      ext(0, 0, w, h + e);
    }

    function cylinder(w, h, e){
      var rr0 = edgePx();
      if (rr0 >= 0.8) return cylinderRound(w, h, e, rr0);
      if (axial){
        add({ left:'0', top:px(h), width:px(w), height:px(e), 'border-radius':'50%', background:SH + ',' + B });
        add({ left:'0', top:px(h/2 + e/2), width:px(w), height:px(h/2 + 0.5), background:SH + ',' + B });
        add({ left:'0', top:px(h/2), width:px(w), height:px(e), 'border-radius':'50%', background:SH + ',' + A });
        add({ left:'0', top:px(e/2), width:px(w), height:px(h/2 + 0.5), background:SH + ',' + A });
        add({ left:'0', top:'0', width:px(w), height:px(e), 'border-radius':'50%', background:HL + ',' + A, 'box-shadow':RIM });
      } else {
        add({ left:'0', top:px(h), width:px(w), height:px(e), 'border-radius':'50%', background:SH + ',' + split });
        add({ left:'0', top:px(e/2), width:px(w), height:px(h), background:SH + ',' + split });
        add({ left:'0', top:'0', width:px(w), height:px(e), 'border-radius':'50%', background:HL + ',' + split, 'box-shadow':RIM });
      }
      ext(0, 0, w, h + e);
    }

    var w, h, e, gap = 18, alt;
    if (spec.shape === 'disc' || spec.shape === 'ring'){
      sc = maxPx / Math.max(v.d, v.t);
      w = r(v.d*sc); h = r(Math.max(v.t*sc, 2)); e = r(Math.max(w*tilt, 3));
      pf = r(Math.min(26, Math.max(10, Math.min(e, w/2) * 0.5)));
      cylinder(w, h, e);
      if (spec.cs && spec.shape === 'disc') countersink(w/2, e/2, 0, e/w, h, sc);
      var wi = 0, ei = 0;
      if (spec.shape === 'ring'){
        wi = r(v.id*sc); ei = r(wi*tilt);
        var hole = [];
        if (axial){
          hole.push(node({ left:'0', top:'0', width:'100%', height:px(h/2 + ei/2), background:A }));
          hole.push(node({ left:'0', top:px(h/2), width:'100%', height:px(ei), 'border-radius':'50%', background:B }));
        }
        hole.push(node({ left:'0', top:'0', width:'100%', height:'100%', background:'linear-gradient(90deg,rgba(0,0,0,.18),rgba(0,0,0,.42) 30%,rgba(0,0,0,.30) 70%,rgba(0,0,0,.12))' }));
        hole.push(node({ left:'0', top:px(h), width:'100%', height:px(ei), 'border-radius':'50%', background:cfg.bg }));
        out.push(node({ left:px((w-wi)/2), top:px((e-ei)/2), width:px(wi), height:px(ei), 'border-radius':'50%', overflow:'hidden',
                        background:axial ? B : split, 'box-shadow':'inset 0 1px 1px rgba(0,0,0,.25)' }, null, hole.join('')));
      }
      if (cfg.letters){
        if (axial){
          poleStack(w/2, e + h/4, e + 0.75*h, h/2, w);
        } else {
          var dsz = Math.min(26, w*0.3, h/1.15);
          if (dsz >= 9){ pole(w*0.27, e + h/2, aL, r(dsz)); pole(w*0.73, e + h/2, bL, r(dsz)); }
        }
      }
      if (cfg.dims){
        hDim(0, w, h + e + 14, h + e/2 + 4, phi + L('d'));
        vDim(w + gap, e/2, e/2 + h, w, L('t'));
        if (spec.shape === 'ring') hDim((w-wi)/2, (w+wi)/2, -14, e/2 - 3, phi + L('id'), true);
      }
      alt = spec.shape === 'disc' ? 'Disc magnet, ' + L('d') + ' diameter by ' + L('t') + ' thick'
                                  : 'Ring magnet, ' + L('d') + ' outer diameter, ' + L('id') + ' inner diameter, ' + L('t') + ' thick';
    }

    else if (spec.shape === 'sphere'){
      w = r(maxPx); e = r(w*tilt);
      pf = r(Math.min(28, Math.max(10, w*0.13)));
      var inner = [];
      if (axial){
        inner.push(node({ left:'0', top:'0', width:'100%', height:'50%', background:A }));
        inner.push(node({ left:'0', top:px(w/2 - e/2), width:'100%', height:px(e), 'border-radius':'50%', background:A }));
      }
      inner.push(node({ left:'0', top:'0', width:'100%', height:'100%', background:GLOSS
        ? 'radial-gradient(circle at 33% 27%,rgba(255,255,255,.98) 0,rgba(255,255,255,.85) 3.5%,rgba(255,255,255,0) 13%),radial-gradient(circle at 38% 32%,rgba(255,255,255,.38),rgba(255,255,255,0) 42%),radial-gradient(ellipse 45% 18% at 58% 88%,rgba(255,255,255,.30),rgba(255,255,255,0) 100%),radial-gradient(circle at 45% 40%,rgba(0,0,0,0) 45%,rgba(0,0,0,.55) 100%)'
        : 'radial-gradient(circle at 36% 30%,rgba(255,255,255,.55),rgba(255,255,255,0) 38%),radial-gradient(circle at 50% 50%,rgba(0,0,0,0) 52%,rgba(0,0,0,.38) 100%)' }));
      out.push(node({ left:'0', top:'0', width:px(w), height:px(w), 'border-radius':'50%', overflow:'hidden', background:axial ? B : split }, null, inner.join('')));
      ext(0, 0, w, w);
      if (cfg.letters){
        if (axial){ pole(w/2, w*0.26, aL); pole(w/2, w/2 + e/2 + (w/2 - e/2)/2, bL); }
        else { pole(w*0.28, w/2, aL); pole(w*0.72, w/2, bL); }
      }
      if (cfg.dims) hDim(0, w, w + 14, w/2 + 4, phi + L('d'));
      alt = 'Sphere magnet, ' + L('d') + ' diameter';
    }

    else if (spec.shape === 'block'){
      sc = maxPx / Math.max(v.w, v.l, v.t);
      w = r(v.w*sc); h = r(Math.max(v.t*sc, 2));
      pf = r(Math.min(26, Math.max(10, Math.min(w, h) * 0.3)));
      var FRONT = GLOSS
        ? 'linear-gradient(105deg,rgba(0,0,0,.14) 0%,rgba(255,255,255,.08) 18%,rgba(255,255,255,.62) 27%,rgba(255,255,255,.12) 33%,rgba(255,255,255,0) 48%,rgba(255,255,255,.20) 70%,rgba(255,255,255,0) 78%,rgba(0,0,0,.20) 100%)'
        : 'linear-gradient(90deg,rgba(0,0,0,.06),rgba(255,255,255,.14) 35%,rgba(255,255,255,.04) 65%,rgba(0,0,0,.10))';
      var TOP = GLOSS
        ? 'linear-gradient(100deg,rgba(255,255,255,.55) 0%,rgba(255,255,255,.16) 30%,rgba(255,255,255,.34) 55%,rgba(255,255,255,.06) 75%,rgba(255,255,255,.18) 100%)'
        : 'linear-gradient(90deg,rgba(255,255,255,.22),rgba(255,255,255,.08))';
      var poly = function(pts){ return 'polygon(' + pts.map(function(p){ return r(p[0]) + 'px ' + r(p[1]) + 'px'; }).join(',') + ')'; };
      var mid = h/2;

      if (spec.cs){
        var turn = (+cfg.csBlockTurn || 24) * Math.PI/180, ct = Math.cos(turn), st = Math.sin(turn);
        var Lp = v.l*sc;
        var P0 = function(X, Y, Z){ return [X*ct + Z*st, -Y - (Z*ct - X*st)*tilt]; };
        var mnx = Infinity, mny = Infinity, mxx = -Infinity, mxy = -Infinity;
        [0, w].forEach(function(X){ [0, h].forEach(function(Y){ [0, Lp].forEach(function(Z){
          var q = P0(X, Y, Z); mnx = Math.min(mnx, q[0]); mny = Math.min(mny, q[1]); mxx = Math.max(mxx, q[0]); mxy = Math.max(mxy, q[1]);
        }); }); });
        var P = function(X, Y, Z){ var q = P0(X, Y, Z); return [q[0] - mnx, q[1] - mny]; };
        var BW = mxx - mnx, BH = mxy - mny;
        var faceO = function(bg, pts){ add({ left:'0', top:'0', width:px(BW), height:px(BH), background:bg, 'clip-path':poly(pts), '-webkit-clip-path':poly(pts) }); };
        var SIDEO = 'linear-gradient(90deg,rgba(0,0,0,.26),rgba(0,0,0,.40))';
        var startO = out.length, rrO = Math.min(edgePx(), h*0.45, w*0.3, Lp*0.3);
        faceO(TOP + ',' + A, [P(0,h,0), P(w,h,0), P(w,h,Lp), P(0,h,Lp)]);
        faceO(FRONT + ',' + A, [P(0,h,0), P(w,h,0), P(w,mid,0), P(0,mid,0)]);
        faceO(FRONT + ',' + B, [P(0,mid,0), P(w,mid,0), P(w,0,0), P(0,0,0)]);
        faceO(SIDEO + ',' + A, [P(w,h,0), P(w,h,Lp), P(w,mid,Lp), P(w,mid,0)]);
        faceO(SIDEO + ',' + B, [P(w,mid,0), P(w,mid,Lp), P(w,0,Lp), P(w,0,0)]);
        var e1 = P(0,h,0), e2 = P(w,h,0), e3 = P(w,0,0), hl = GLOSS ? 'rgba(255,255,255,.75)' : 'rgba(255,255,255,.35)';
        if (rrO >= 0.8){
          roundBlock(startO, BW, BH, [P(0,0,0), P(w,0,0), P(w,0,Lp), P(w,h,Lp), P(0,h,Lp), P(0,h,0)],
                     [[P(0,h,0), P(w,h,0)], [P(w,h,0), P(w,h,Lp)], [P(w,h,0), P(w,0,0)]], rrO);
        } else {
          faceO(hl, [e1, e2, [e2[0], e2[1] + 1.2], [e1[0], e1[1] + 1.2]]);
          faceO(GLOSS ? 'rgba(255,255,255,.45)' : 'rgba(255,255,255,.25)', [e2, [e2[0] + 1.2, e2[1]], [e3[0] + 1.2, e3[1]], e3]);
        }
        ext(0, 0, BW, BH);
        var holes = [[w/2, Lp/2]], sp2 = spec.cs.Sm ? spec.cs.Sm*sc : 0;
        if (sp2 > 0) holes = w >= Lp ? [[w/2 - sp2/2, Lp/2], [w/2 + sp2/2, Lp/2]] : [[w/2, Lp/2 + sp2/2], [w/2, Lp/2 - sp2/2]];
        holes.forEach(function(hp, i){ var q = P(hp[0], h, hp[1]); countersink(q[0], q[1], 0, tilt, h, sc, i === 0); });
        if (holes.length === 2 && cfg.dims){
          var q1 = P(holes[0][0], h, holes[0][1]), q2 = P(holes[1][0], h, holes[1][1]), spc = spec.cs.spacing;
          var apTxt = label(spc.raw, spc.v, spc.unit, cfg.conv, cfg.inch) + ' apart';
          if (w >= Lp)
            hDim(Math.min(q1[0], q2[0]), Math.max(q1[0], q2[0]), -14 - 2*(TH + 18), Math.min(q1[1], q2[1]) - 2, apTxt, true);
          else
            sDim(q2[0], q2[1], q1[0], q1[1], apTxt, -(w*ct/2 + 30));
        }
        if (cfg.letters){
          var pu = P(w/2, h*0.75, 0), pl = P(w/2, h*0.25, 0);
          poleStack(pu[0], pu[1], pl[1], mid, w*ct);
        }
        if (cfg.dims){
          var a0 = P(0,0,0), a1 = P(w,0,0), a2 = P(w,0,Lp), tt = P(w,h,Lp);
          sDim(a0[0], a0[1], a1[0], a1[1], L('w'), 16);
          sDim(a1[0], a1[1], a2[0], a2[1], L('l'), 16);
          vDim(a2[0] + gap, tt[1], a2[1], a2[0], L('t'));
        }
      } else {
        var kf = Math.min(0.75, tilt*1.6);
        var dep = v.l*sc*kf;
        var dx = r(dep*Math.cos(Math.PI/6)), dy = r(dep*Math.sin(Math.PI/6));
        var W = w + dx, H = dy + h;
        var face = function(bg, pts){ add({ left:'0', top:'0', width:px(W), height:px(H), background:bg, 'clip-path':poly(pts), '-webkit-clip-path':poly(pts) }); };
        var SIDE = GLOSS
          ? 'linear-gradient(90deg,rgba(255,255,255,.28) 0%,rgba(0,0,0,.30) 12%,rgba(0,0,0,.42) 100%)'
          : 'linear-gradient(rgba(0,0,0,.30),rgba(0,0,0,.30))';
        var startB = out.length, rrB = Math.min(edgePx(), h*0.45, w*0.3, Math.max(dy, 1)*0.9);
        face(TOP + ',' + A, [[0,dy],[w,dy],[W,0],[dx,0]]);
        face(FRONT + ',' + A, [[0,dy],[w,dy],[w,dy+mid],[0,dy+mid]]);
        face(FRONT + ',' + B, [[0,dy+mid],[w,dy+mid],[w,H],[0,H]]);
        face(SIDE + ',' + A, [[w,dy],[W,0],[W,mid],[w,dy+mid]]);
        face(SIDE + ',' + B, [[w,dy+mid],[W,mid],[W,h],[w,H]]);
        if (rrB >= 0.8){
          roundBlock(startB, W, H, [[0,H],[w,H],[W,h],[W,0],[dx,0],[0,dy]],
                     [[[0,dy],[w,dy]], [[w,dy],[W,0]], [[w,dy],[w,H]]], rrB);
        } else {
          add({ left:'0', top:px(dy), width:px(w), height:'1px', background:GLOSS ? 'rgba(255,255,255,.75)' : 'rgba(255,255,255,.35)' });
        }
        ext(0, 0, W, H);
        if (cfg.letters) poleStack(w/2, dy + mid/2, dy + mid*1.5, mid, w);
        if (cfg.dims){
          hDim(0, w, H + 14, H + 4, L('w'));
          vDim(W + gap, 0, h, W, L('t'));
          if (dx > 4) sDim(w, H, W, h, L('l'), 16);
        }
      }
      alt = 'Block magnet, ' + L('w') + ' wide by ' + L('l') + ' long by ' + L('t') + ' thick';
    }

    if (spec.cs && spec.cs.Sm && spec.shape === 'block') alt += ', two countersunk holes ' + trimNum(spec.cs.spacing.v, 3) + ' ' + spec.cs.spacing.unit + ' apart';
    if (spec.cs) alt += ', countersunk ' + trimNum(spec.cs.D, 3) + ' by ' + trimNum(spec.cs.H, 3) + ' ' + spec.cs.unit + ' at ' + trimNum(spec.cs.angle, 1) + ' degrees';
    if (cfg.caption){
      var cxm = (bx.x1 + bx.x2) / 2, cyTop = bx.y2 + 10, cw = textW(cfg.caption);
      out.push(node({ left:px(cxm), top:px(cyTop), transform:'translateX(-50%)', 'white-space':'nowrap', 'line-height':'1.2', 'font-weight':'600' }, cfg.caption));
      ext(cxm - cw/2, cyTop, cxm + cw/2, cyTop + TH);
      alt += ', ' + cfg.caption.toLowerCase();
    }
    var body = out.join('\n');
    if (GLOSS){
      var gk = parseFloat(cfg.glossIntensity); if (!(gk >= 0)) gk = 1;
      var gc = hexRgb(cfg.glossColor) || [255, 255, 255];
      if (gk !== 1 || gc.join(',') !== '255,255,255'){
        body = body.replace(/rgba\(255,255,255,\s*([\d.]+)\)/g, function(m, a){
          return 'rgba(' + gc.join(',') + ',' + r(Math.min(1, parseFloat(a) * gk)) + ')';
        });
      }
    }
    var ox = r(-bx.x1 + 1), oy = r(-bx.y1 + 1);
    var width = Math.ceil(bx.x2 - bx.x1 + 2), height = Math.ceil(bx.y2 - bx.y1 + 2);
    var html = '<div role="img" aria-label="' + esc(alt + ', ' + where) + '" style="' +
      esc('position:relative;display:inline-block;vertical-align:top;text-align:left;width:' + width + 'px;height:' + height + 'px;font-family:inherit;font-size:' + fs + 'px;line-height:1.2;color:' + c) +
      '">\n<div style="position:absolute;left:' + ox + 'px;top:' + oy + 'px">\n' + body + '\n</div>\n</div>';
    return { html:html, width:width, height:height };
  }

  return { parseLen:parseLen, parseSize:parseSize, parseCs:parseCs, addCs:addCs, csVariants:csVariants, parseDir:parseDir, parseNum:parseNum, build:build, label:label, DEFAULTS:DEFAULTS };
})();


  var SLIDE_ID = 'te-magnet-drawing';

  function options(o, gallery, thumb, variant){
    var opts = {
      north:o.north, south:o.south, axialNorth:o.axialNorth, diametricNorth:o.diametricNorth,
      max: thumb ? 200 : (gallery ? +o.gmax : +o.max), tilt:+o.tilt, csTilt:+o.cstilt, edgeRadius:o.er,
      dims: thumb ? false : o.dims === 'true', letters:o.letters === 'true',
      phi:o.phi === 'true', conv:o.conv === 'true', dimColor:o.dimcolor, fs:+o.fs,
      inch:o.inch || '"', bg:o.bg, finish:o.finish, glossIntensity:o.gk, glossColor:o.gc
    };
    for (var k in variant || {}) opts[k] = variant[k];
    if (thumb){ opts.caption = ''; if (o.tfinish) opts.finish = o.tfinish; }
    return opts;
  }

  function fitInto(box, fill){
    var d = box.firstChild; if (!d || !box._teW) return;
    var cw = box.clientWidth, ch = box.clientHeight;
    if (!cw || !ch) return;
    d.style.zoom = Math.min(cw*fill/box._teW, ch*fill/box._teH);
  }

  function fit(wrap){
    var items = wrap.querySelectorAll('[data-te-w]');
    for (var i = 0; i < items.length; i++){
      var el = items[i]; el.style.zoom = '';
      var s = Math.min(1, wrap.clientWidth / +el.getAttribute('data-te-w'));
      if (s < 1) el.style.zoom = s;
    }
  }

  function drawInline(wrap, spec, variants){
    var html = variants.map(function(v){
      var out = TeMag.build(spec, options(wrap.dataset, false, false, v));
      return out.html.replace('<div role="img"', '<div data-te-w="' + out.width + '" role="img"');
    });
    wrap.innerHTML = html.length > 1 ? '<div class="te-mag-row">' + html.join('') + '</div>' : html[0];
    wrap.hidden = false;
    fit(wrap);
  }

  function centerBox(html, w, h){
    var sq = document.createElement('div'); sq.className = 'te-mag-square';
    var c = document.createElement('div'); c.className = 'te-mag-center';
    c.innerHTML = html; c._teW = w; c._teH = h;
    sq.appendChild(c);
    return { square:sq, center:c };
  }

  function drawGallery(wrap, spec, variants){
    var cont = document.querySelector('[id^="productPhotoContainer-"]');
    if (!cont) return false;
    if (document.getElementById(SLIDE_ID + '-1')) return true;
    var sid = cont.id.replace('productPhotoContainer-', '');
    var photos = [].slice.call(cont.querySelectorAll('[id^="productPhotoWrapper-' + sid + '"]'));
    if (!photos.length) return false;
    var o = wrap.dataset, pos = Math.max(2, parseInt(o.gpos, 10) || 2);

    var thumbs = document.getElementById('productThumbs-' + sid), created = false;
    if (!thumbs){
      created = true;
      thumbs = document.createElement('ul');
      thumbs.className = 'product-photo-thumbs grid-uniform';
      thumbs.id = 'productThumbs-' + sid;
      cont.parentNode.insertBefore(thumbs, cont.nextSibling);
      var img = photos[0].querySelector('img');
      var li0 = document.createElement('li');
      li0.className = 'grid-item medium-down--one-quarter large--one-quarter';
      li0.innerHTML = '<a href="#" class="product-photo-thumb product-photo-thumb-' + sid + '" data-image-id="' + photos[0].getAttribute('data-image-id') + '"></a>';
      if (img){
        var im = document.createElement('img');
        im.src = (img.getAttribute('data-src') || img.src).replace('{width}', '160'); im.alt = img.alt || '';
        li0.firstChild.appendChild(im);
      }
      thumbs.appendChild(li0);
    }
    var liClass = thumbs.children.length ? thumbs.children[0].className : 'grid-item medium-down--one-quarter large--one-quarter';

    var refImg = thumbs.querySelector('a.product-photo-thumb:not(.te-mag-thumb-link) img');
    var frame = function(sq){
      var tb = String(o.tborder || 'auto').trim();
      if (tb === 'auto'){
        if (refImg && window.getComputedStyle){
          var cs = getComputedStyle(refImg);
          ['Top','Right','Bottom','Left'].forEach(function(sd){
            sq.style['border' + sd + 'Width'] = cs['border' + sd + 'Width'];
            sq.style['border' + sd + 'Style'] = cs['border' + sd + 'Style'];
            sq.style['border' + sd + 'Color'] = cs['border' + sd + 'Color'];
          });
          sq.style.borderRadius = cs.borderRadius;
          if (cs.boxShadow && cs.boxShadow !== 'none') sq.style.boxShadow = cs.boxShadow;
        } else sq.style.border = '1px solid #e3e3e3';
      } else if (tb && tb !== 'none') sq.style.border = tb;
    };

    var slides = [], links = [], mains = [], minis = [];
    var afterEl = photos[Math.min(pos - 2, photos.length - 1)];
    var beforeLi = thumbs.children[Math.min(pos - 1, thumbs.children.length)] || null;
    variants.forEach(function(v, i){
      var big = TeMag.build(spec, options(o, true, false, v));
      var slide = document.createElement('div');
      slide.id = SLIDE_ID + '-' + (i + 1);
      slide.setAttribute('data-image-id', slide.id);
      slide.style.maxWidth = photos[0].style.maxWidth || '700px';
      slide.style.margin = '0 auto';
      slide.style.display = 'none';
      var main = centerBox(big.html, big.width, big.height);
      var pad = String(o.gpad || '').trim();
      if (pad && pad !== '0') main.center.style.top = /^\d*\.?\d+$/.test(pad) ? pad + 'px' : pad;
      slide.appendChild(main.square);
      afterEl.parentNode.insertBefore(slide, afterEl.nextSibling);
      afterEl = slide;

      var small = TeMag.build(spec, options(o, true, true, v));
      var li = document.createElement('li'); li.className = liClass;
      var a = document.createElement('a');
      a.href = '#';
      a.className = 'product-photo-thumb te-mag-thumb-link';
      a.setAttribute('data-image-id', slide.id);
      a.setAttribute('aria-label', 'Show magnet polarity drawing' + (v.caption ? ': ' + v.caption : ''));
      var mini = centerBox(small.html, small.width, small.height);
      frame(mini.square);
      a.appendChild(mini.square);
      li.appendChild(a);
      thumbs.insertBefore(li, beforeLi);
      fitInto(mini.center, 0.86);
      slides.push(slide); links.push(a); mains.push(main); minis.push(mini);
    });

    function hideDrawings(){ slides.forEach(function(sl){ sl.style.display = 'none'; }); }
    function showDrawing(i){
      photos.forEach(function(p){ p.classList.add('hide'); });
      hideDrawings();
      slides[i].style.display = '';
      fitInto(mains[i].center, 0.88);
    }

    thumbs.addEventListener('click', function(e){
      var t = e.target.closest ? e.target.closest('a.product-photo-thumb') : null;
      if (!t) return;
      var i = links.indexOf(t);
      if (i > -1){ e.preventDefault(); showDrawing(i); return; }
      hideDrawings();
      if (created){
        e.preventDefault();
        var id = t.getAttribute('data-image-id');
        photos.forEach(function(p){ p.classList.toggle('hide', p.getAttribute('data-image-id') !== id); });
      }
    });

    if (window.MutationObserver){
      var mo = new MutationObserver(function(){
        if (photos.some(function(p){ return !p.classList.contains('hide'); })) hideDrawings();
      });
      photos.forEach(function(p){ mo.observe(p, { attributes:true, attributeFilter:['class'] }); });
    }

    window.addEventListener('resize', function(){
      minis.forEach(function(m){ fitInto(m.center, 0.86); });
      slides.forEach(function(sl, i){ if (sl.style.display !== 'none') fitInto(mains[i].center, 0.88); });
    });
    return true;
  }

  function draw(wrap){
    var o = wrap.dataset;
    var spec = TeMag.parseSize(o.size, o.dir, o.unit);
    if (spec.error){
      if (window.console) console.warn('Magnet drawing skipped (' + spec.error + ') Size: "' + o.size + '", direction: "' + o.dir + '"');
      return;
    }
    TeMag.addCs(spec, o.cs);
    if (spec.csError && window.console) console.warn('Countersink not drawn (' + spec.csError + ') Value: "' + o.cs + '"');
    var variants = TeMag.csVariants(spec, o.dir);
    if (o.placement === 'gallery' && drawGallery(wrap, spec, variants)) return;
    drawInline(wrap, spec, variants);
  }

  function init(){
    var list = document.querySelectorAll('.te-mag-wrap:not([data-te-done])');
    for (var i = 0; i < list.length; i++){ list[i].setAttribute('data-te-done',''); draw(list[i]); }
  }

  TeMag.init = init;
  window.TeMag = TeMag;
  var t;
  window.addEventListener('resize', function(){
    clearTimeout(t);
    t = setTimeout(function(){
      var l = document.querySelectorAll('.te-mag-wrap[data-te-done]:not([hidden])');
      for (var i = 0; i < l.length; i++) fit(l[i]);
    }, 120);
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();